import departmentList from "./departmentList";

function emptyArr(arr) {
  const check = !Array.isArray(arr) || arr === null;
  return check;
}

function deptLongToShort(dept) {
  for (const key in departmentList) {
    if (departmentList[key] === dept) {
      return key;
    }
  }

  return null;
}

export { emptyArr, deptLongToShort };
